import React from "react";
import { Button, Stack } from "@mui/material";
import _ from "lodash";
import Topbar from "../navigation/topBar";
import "../index.css";
import MiWidget from "./miWidget";
import "./mi.css";
import MiImageAnalysis from "./imageAnalysisViewer";
// import StickyButton from "../ImageViewer/StickyButton";

export default function Context({ toggleComponent }) {
  return (
    <Stack sx={{ backgroundColor: "rgba(255, 255, 255)", height: "100vh" }}>
      <Topbar
        logo="Constems-AI"
        title={"Motor Insurance Inspection"}
        user={sessionStorage.getItem("user")}
        user_icon={true}
      />

      <div className="container_styles">
        <div
          style={{ margin: "0.75rem", marginTop: "4rem" }}
        >
          {/* <MiImageAnalysis /> */}
          <MiWidget />
        </div>
      </div>
    </Stack>
  );
}
